import { Component, OnInit } from '@angular/core';



import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import {Angular2CsvModule} from 'angular2-csv';
import { MyDatePickerModule, IMyDpOptions } from 'mydatepicker';
import { CallBackEndService } from '../call-back-end.service';
declare var getHexAscii: any;
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import * as jsPDF from 'jspdf';
import 'rxjs/Rx';

@Component({
  selector: 'app-upi-menu',
  templateUrl: './upi-menu.component.html',
  styleUrls: ['./upi-menu.component.css']
})
export class UpiMenuComponent implements OnInit {


  scAccounts: any [];
  accountInfo: any ;
  debitCardAcct : string ='';
  balance : string ='';
  selectedStopPayment : string ='';
  selectedBalance : string='';
  crr : string='';
  stopPaymentAcct : string='';
  selectedCurrencyCode : string='';
  isShow : string='page1';
  debitCardAddress : any;
  transactionPin : string ='';
  error : string ='';
  cardCat : string ='';
  EmbossingName : string ='';
  otp : string ='';
  debitCardNumber : string='' ;
  addressDetails : any=[];
  disableSub1Btn:boolean=false;
  disableSub2Btn:boolean=false;
  cardAccRequired:string='';
  cardNoRequired:string='';
  otpRequired:string='';
  isCardError:boolean=false;
  showError:string="";
  generatedOtp : string='';
  invalidOTP : string='';
  successMsg:string="";
  atmLimit: number;
  posLimit: number;
  selectedCardId: any;
  cardStatus: boolean;
  posStatus: boolean;
  atmStatus: boolean;
  atmReadOnly: boolean;
  showSaveBtnForAtm: string;
  posReadOnly: boolean;
  showSaveBtnForPos: string;
  caseParam: string;
  processMsg: string;
  errorFromBackend: boolean;
  errorMsg: string;
  errorForPage1: string;
  error1: string;
  unMaskedCardNo: any;
  OtpNotlank: string;
  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum = /^[0-9]+$/;
  cardLimitStatus: boolean;
  perTxnLimit: number;
  perDayTxn: number;
  userPerweektransAmtlmt: number;
  userPerweektransCountlmt: number;
  UserPermonthtransAmtlmt: number;
  status: string;

  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) {
    this.scAccounts =JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.accountInfo=JSON.stringify(JSON.parse(sessionStorage.getItem('accountInfo')));

  }

  getStatus(i){
    
    this.spinnerService.show();
    let request : IbRequest = new IbRequest();
    
    request.param1 = getHexAscii("",this.debitCardAcct);
    request.param2 = this.debitCardAcct;
    request.param3 = sessionStorage.getItem('mobileno');
    this.webService.getResponse(request, 'fetchactstatus').subscribe((data: IbResponse) => {
      this.spinnerService.hide();
      if(data.status==='S200'){
        // alert("Param5 is:"+data.param5.UserPermonthtransAmtlmt);
        this.cardStatus = + +data.param5.cardStatus==1 ? true : false;
        this.cardLimitStatus = + +data.param5.cardLimitStatus==1 ? true : false;
        if( this.cardStatus && !this.cardLimitStatus){
          this.isCardError=true;
          this.showError=data.param1;
        }else{
          this.isCardError=false;
          this.showError='';
        }
        //this.selectedCardId =  this.addressDetails[i].maskedCardNo;
        if(this.cardStatus && this.cardLimitStatus){
        this.atmLimit = +data.param5.ATMLimit;
        this.perTxnLimit = +data.param5.PerTxnLimit;
        //this.perDayTxn = +data.param5.perDayTxn;
    //this.posLimit =  +data.param5.POSLimit;
    this.userPerweektransAmtlmt = +data.param5.UserPerweektransAmtlmt
    this.UserPermonthtransAmtlmt = +data.param5.UserPermonthtransAmtlmt
    //this.userPerweektransCountlmt = +data.param5.UserPerweektransCountlmt
    
    this.atmStatus = +data.param5.ATMStatus==1 ? true : false;
    this.posStatus = +data.param5.POSStatus==1 ? true : false;
    
   
    this.atmReadOnly = true;
    this.posReadOnly = true;
    this.showSaveBtnForAtm = 'no';
    this.showSaveBtnForPos = 'no';
        }
      }
    });
  }

  getLimits(i){
    console.log('index----: '+i+'  debitCardAcct : '+this.debitCardAcct);
    this.atmLimit = +this.addressDetails[i].ATMLimit;
    this.posLimit = +this.addressDetails[i].POSLimit;
    this.atmStatus = +this.addressDetails[i].ATMStatus==1 ? true : false;
    this.posStatus = +this.addressDetails[i].POSStatus==1 ? true : false;
    this.cardStatus = +this.addressDetails[i].cardStatus==1 ? true : false;
    this.selectedCardId = this.addressDetails[i].cardId;
    this.atmReadOnly = true;
    this.posReadOnly = true;
    this.showSaveBtnForAtm = 'no';
    this.showSaveBtnForPos = 'no';
  }

  changeAtmReadOnlyToInput(){
    this.atmReadOnly = false;
    console.log('atmReadOnly  : '+this.atmReadOnly);
    this.showSaveBtnForAtm='yes';
  }
  changePosReadOnlyToInput(){
    this.posReadOnly=false;
    this.showSaveBtnForPos = 'yes';
  }
  
  changeAtmlimit()
  {
    this.atmReadOnly=false;
    this.showSaveBtnForAtm='yes';
    
  }
  blockCard(){ 
      
        //console.log("Implement blobk functionality ");
          this.genrateOtpReturnFunc(); 
         // this.isShow='page2';
          this.processMsg = 'Enter OTP to Block Your Customer '+sessionStorage.getItem('mobileno');;
          this.caseParam = 'ACTIVE';
          this.status = "2";

          console.log('this.caseParam    : '+this.caseParam);      
      
    
  }
  unblockCard(){
    
     // console.log("Implement blobk functionality ");
     this.genrateOtpReturnFunc();     
      this.processMsg = 'Enter OTP to ACTIVE Your Customer '+sessionStorage.getItem('mobileno');
      this.caseParam = 'ACTIVE';
      this.status = "1";      
    
  }
 
  blockAtmTransactions(){
    
      this.genrateOtpReturnFunc(); 
       this.processMsg = 'Enter OTP to Block ATM Transactions of Card '+this.selectedCardId;
       this.caseParam = 'atmBlock';
       
     
  }
  unblockAtmTransactions(){
    this.genrateOtpReturnFunc(); 
    this.processMsg = 'Enter OTP to UnBlock ATM Transactions of Card '+this.selectedCardId;
    this.caseParam = 'atmUnBlock';
  }
  blockPosTransactions(){
    this.genrateOtpReturnFunc(); 
    this.processMsg = 'Enter OTP to UnBlock POS Transactions of Card '+this.selectedCardId;
    this.caseParam = 'posBlock';
  }
  unblockPosTransactions(){
    this.genrateOtpReturnFunc(); 
    this.processMsg = 'Enter OTP to UnBlock POS Transactions of Card '+this.selectedCardId;
    this.caseParam = 'posUnBlock';
  }
  savePosLimit(){
    this.genrateOtpReturnFunc(); 
    this.processMsg = 'Enter OTP to change IMPS Transaction Limit ';
    this.caseParam = 'posLimitChange';
  }
  saveAtmLimit(){
    this.genrateOtpReturnFunc(); 
    this.processMsg = 'Enter OTP to change IMPS Transaction Limit';
    this.caseParam = 'atmLimitChange';
  }
 
  // getBalanceAndCrr()
  // {

  //    this.spinnerService.show();
  //   this.cardNoRequired='';
  //   const request: IbRequest = new IbRequest();
  //   const response: IbResponse = null;
  //   request.param1 = getHexAscii('', this.debitCardAcct);
  //   request.param2 = this.debitCardAcct;
  //   this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
  //      this.spinnerService.hide();
  //     if (data !== null && data.status === 'S200') {
  //       this.balance = data.param5.clrBalanceStr;
  //       this.selectedStopPayment = this.stopPaymentAcct;
  //       this.selectedBalance = this.balance;
  //       this.crr = 'INR';
  //       this.selectedCurrencyCode =  this.crr;
  //       console.log('efaf'+this.balance+this.selectedStopPayment+this.selectedBalance);

  //     } else{
  //       alert(data);
  //     }
  //   });
  // }
  
   
  genrateOtpReturnFunc(){
    let outputMsg='Fail';
    if(this.debitCardAcct===""||this.debitCardAcct===" "||this.debitCardAcct===undefined)
    {
      this.cardAccRequired='no';
      return false;
    }else{
      this.otp=undefined;
      this.errorFromBackend=false;
      this.disableSub1Btn=true;
      this.spinnerService.show();
     const request: IbRequest = new IbRequest();
     request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName'));
     request.param2 =sessionStorage.getItem('storedUserName');
     this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
      this.spinnerService.hide();
      outputMsg = data.status;
     
       console.log('returning outputMsg    ------  >'+outputMsg);
       //return outputMsg;
      if(data.status==='S200'){
        this.isShow='page2';
     
      }else{
        this.errorForPage1='yes';
        this.error1 = data.param1;
        
      }
      
     });
   
    }
  }
  //generate OTP
  submotSecond(){
   
    if(this.debitCardAcct===""||this.debitCardAcct===" "||this.debitCardAcct===undefined)
    {
      this.cardAccRequired='no';
    }
    else if(this.debitCardNumber===""||this.debitCardNumber===" "||this.debitCardNumber===undefined){
      this.cardNoRequired='no';
    }
    else{
      this.disableSub1Btn=true;
       this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName')+this.debitCardAcct+this.debitCardNumber);
      request.param2 =sessionStorage.getItem('storedUserName');
      request.param3 = this.debitCardAcct;
      request.param4=this.debitCardNumber;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        //this.isLoad = false;
        if (response !== null && response.status === 'S200') {
          // console.log('Otp :' + response.param1);
          this.isShow = 'page2';
          //this.generatedOtp=response.param1;
          this.disableSub1Btn=false;
         
        } else if (response !== null) {
          this.error = response.param1;
          this.disableSub1Btn=false;
         
        } else {
          this.disableSub1Btn=false;
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
        
      });
      
    }
   
  }
  checkAtmlimit(){
    console.log('this.atmLimit   :'+this.atmLimit);
    if(this.atmLimit==undefined || this.atmLimit==null){
      console.log('cant be null limit');
      this.errorForPage1='yes';
      this.error1='Please enter ATM Limit';
    }
  }
  submotIOTP()
  { if(this.validateOtp()){
    console.log('casePar     ----> '+this.caseParam);
    if(this.otp===""||this.otp===" "||this.otp===undefined)
    {
      this.otpRequired='no';
    }
    // else if(this.otp!== this.generatedOtp)
    // {
    //   this.invalidOTP='no';
    // }
    else{
      this.disableSub2Btn=true;
    
      const request: IbRequest = new IbRequest();
     
      //this.isLoad = true;
      request.param1 = getHexAscii('', this.debitCardAcct+sessionStorage.getItem('mobileno')+getHexAscii('',this.otp)+sessionStorage.getItem('storedUserName'));
      request.param2 = this.debitCardAcct;
      request.param3 = sessionStorage.getItem('mobileno');
      request.param4 =  getHexAscii('',this.otp);
       request.param5=sessionStorage.getItem('storedUserName');
        let otherDetails = { "caseParam" : this.caseParam,"status" : this.status };
       console.log(otherDetails);
       request.param6 = otherDetails;
       this.spinnerService.show();
       //if(this.caseParam==='cardBlock'){
         console.log('calling webService for Card block');
        // this.webService.getResponse(request, 'upmobbankstatus').subscribe((data: IbResponse) => {
        this.webService.getResponse(request, 'upistatus').subscribe((data: IbResponse) => {
           this.spinnerService.hide();
          
           if(data.status==='S200'){
            this.processMsg = '';
            this.caseParam='';
             this.isShow='page3';
             this.successMsg = data.param1;
           }else{        
            this.errorFromBackend=true;
            this.errorMsg = data.param1;
            this.disableSub2Btn=false;
           }
          });
      // }
      //  else if(this.caseParam==='cardUnBlock'){
      //   this.webService.getResponse(request, 'debitCardUnBlock').subscribe((data: IbResponse) => {
      //     this.spinnerService.hide();
      //     if(data.status==='S200'){
      //      this.processMsg = '';
      //      this.caseParam='';
      //       this.isShow='page3';
      //       this.successMsg = data.param1;
      //     }else{        
      //      this.errorFromBackend=true;
      //      this.errorMsg = data.param1;
      //      this.disableSub2Btn=false;
      //     }
      //    }); 
      // }else if(this.caseParam==='atmBlock'){
           
      //  }else if(this.caseParam==='posBlock'){
                
      //  }else if(this.caseParam==='atmUnBlock'){
            
      // }else if(this.caseParam==='posUnBlock'){
        
      // }else if(this.caseParam==='atmLimitChange'){
         
      // }else if(this.caseParam==='posLimitChange'){
         
      // }else{

      // }
      


      // this.webService.getResponse(request, 'cardBlock').subscribe((data: IbResponse) => {
      //   response = data;
      //    this.spinnerService.hide();
      //   //this.isLoad = false;
      //   if (response !== null && response.status === 'S200') {
      //     console.log('Otp :' + response.param1);
      //      this.successMsg=response.param1;
      //     this.isShow = 'page3';
         
      //   } else if (response !== null) {
      //     this.error = response.param1;
      //     this.disableSub2Btn=false;
      //   } else {
      //     this.error = 'Something Went Wrong Please Contact Customer Care';
      //     this.disableSub2Btn=false;
      //   }
      // });
    }
  }
  }
  
  backToPage1(){
    this.isShow='page1';
  }
  ngOnInit() { 
    $(document).ready(function() {
    $('input').bind('copy paste cut',function(e) { 
    e.preventDefault(); //disable cut,copy,paste
    });
   });
  }
  validateOtpOld(){
    if(this.otp===""||this.otp===" "||this.otp===undefined)
    {
      this.otpRequired='no';
    }
  }

  validateOtp() {
    if (this.otp === undefined || this.otp === '') {
      this.OtpNotlank = 'no';
      return false;
    }else if (this.otp.match(this.reg)) {
      this.OtpNotlank = 'specialChar';
      return false;
    }else if (!this.otp.match(this.regNum)) {
      this.OtpNotlank = 'num';
      return false;
    } else if (this.otp.length!=6) {
      this.OtpNotlank = 'len';
      return false;
    }else{
      this.OtpNotlank = '';
      return true;
    }
  }

  removeOtpMsgs(){
    this.otpRequired='';
    this.OtpNotlank='';
    this.invalidOTP='';
    this.errorFromBackend=false;
    this.errorMsg='';
    
  }
}




// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/upi-menu/upi-menu.component.ts